<!-- Last Sync Results Button -->
<button
  *ngIf="showButton"
  mat-raised-button
  [color]="buttonColor"
  class="last-sync-results-button"
  [disabled]="disabled || isLoading"
  (click)="onShowLastSyncResults()"
  [attr.aria-label]="'View last sync results'"
>
  <mat-icon class="icon" [class.spinning]="isLoading" svgIcon="history"></mat-icon>
  <span class="button-text">
    {{ getLabel('lastResultsButton') }}
  </span>
</button>
